import { api, APIResponse } from '@/store/api';
import type { GetInmopublicUsersParams, GetInmopublicUsersResponse } from '@/types/inmopublic-users.types';

export type CreateInmopublicUserRequest = {
  email: string;
  firstName: string;
  lastName: string;
  phone?: number;
  profileImage?: string;
};

export type CreateInmopublicUserResponse = {
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    phone?: number;
    profileImage?: string;
    status: string;
    verified: boolean;
  };
  password: string;
};

export const inmopublicUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInmopublicUsers: builder.query<GetInmopublicUsersResponse, GetInmopublicUsersParams>({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        if (params.page) searchParams.append('page', params.page.toString());
        if (params.limit) searchParams.append('limit', params.limit.toString());
        if (params.text) searchParams.append('text', params.text);
        return {
          url: `admin-inmopublic/users?${searchParams.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response: APIResponse<GetInmopublicUsersResponse>) => response.data,
      providesTags: ['InmopublicUsers'],
    }),
    
    createInmopublicUser: builder.mutation<CreateInmopublicUserResponse, CreateInmopublicUserRequest>({
      query: (userData) => ({
        url: 'admin-inmopublic/users',
        method: 'POST',
        body: userData,
      }),
      transformResponse: (response: APIResponse<CreateInmopublicUserResponse>) => response.data,
      invalidatesTags: ['InmopublicUsers'],
    }),
  }),
});

export const { useGetInmopublicUsersQuery, useCreateInmopublicUserMutation } = inmopublicUsersApi;
